import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlayerButton } from './PlayerButton';
export const SkipBackButton = React.memo(function SkipBackButton({ mediaElementId, onClick }) {
    return (_jsx(PlayerButton, { className: "hekate-player-skip-back-btn", tooltip: "Back 5 seconds", "aria-controls": mediaElementId, onClick: onClick }));
});
